import { createSelector } from '@reduxjs/toolkit';

import type { AppState } from 'redux-store';

export const profileSelector = (state: AppState): AppState['profile'] =>
  state.profile;
export const isAuthSelector = createSelector(
  profileSelector,
  profile => profile.isAuthenticated,
);
